var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 418 853",
    width: 256,
    height: 512,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 418,
    height: 853,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.333299994468689,0,0,1.333299994468689,0,0)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(239,247,122)",
    strokeOpacity: 1,
    strokeWidth: 22,
    d: " M313.80999755859375,31.270000457763672 C44.95000076293945,192.57000732421875 48.77000045776367,499.2200012207031 158.41000366210938,590.5700073242188 C275.739990234375,688.3300170898438 354.79998779296875,559.5499877929688 302.989990234375,506.489990234375 C219.0800018310547,420.55999755859375 -1.940000057220459,624.1599731445312 204.9199981689453,792.5499877929688"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(239,247,122)",
    strokeOpacity: 1,
    strokeWidth: 22,
    d: " M209.9600067138672,714.969970703125 C178.19000244140625,743.2000122070312 188.7100067138672,778.7899780273438 205.02000427246094,793.4600219726562 C195.89999389648438,785.75 181.30999755859375,779.9500122070312 165.4199981689453,780.0700073242188"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5d800793beb072c638667cc0634ca65c.svg";
export { ForwardRef as ReactComponent };